<template>
  <div class="login-form text-center mt-16">
    <div class="card p-8 bg-white w-11/12 max-w-sm md:max-w-none md:w-1/3 mx-auto">
      <h1 class="text-2xl mb-8">Login</h1>
      <div class="text-center">
        <p class="mb-4">Enter your email address and password.</p>
        <!-- email input for login -->
        <div class="input-group">
          <input
            type="email"
            id="email"
            v-model="email"
            placeholder="Email"
            autocomplete="username"
          />
        </div>
        <!-- password input for login -->
        <div class="input-group">
          <input
            type="password"
            id="password"
            v-model="password"
            placeholder="Password"
            autocomplete="current-password"
          />
        </div>
        <!-- login button -->
        <div class="input-group">
          <button class="btn" @click="login">Login</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firebaseApp } from "../database/db.js";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    login() {
      firebaseApp
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$toasted.show("Welcome Back", {
            type: "success",
            theme: "bubble",
            position: "bottom-center",
            duration: 3000,
          });
          this.$router.push("/");
          console.log("logged in");
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.show("Error Logging In", {
            type: "error",
            theme: "bubble",
            position: "bottom-center",
            duration: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss">
.login-form {
  .card {
    border-radius: 5px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
  }
  .input-group {
    label {
      display: block;
    }

    input {
      padding: 5px 8px;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin-bottom: 8px;
    }
  }

  input,
  .btn {
    width: 100%;
    max-width: 300px;
  }

  .btn {
    margin-top: 16px;
  }
}
</style>
